var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnverified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00005 4.17623C6.30381 4.17623 6.55484 4.40195 6.59457 4.69481L6.60005 4.77623V7.20023C6.60005 7.5316 6.33142 7.80023 6.00005 7.80023C5.69629 7.80023 5.44526 7.57451 5.40553 7.28165L5.40005 7.20023V4.77623C5.40005 4.44486 5.66868 4.17623 6.00005 4.17623Z",
    fill: "#FF9400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6 9.6002C6.6 9.93157 6.33137 10.2002 6 10.2002C5.66863 10.2002 5.4 9.93157 5.4 9.6002C5.4 9.26882 5.66863 9.0002 6 9.0002C6.33137 9.0002 6.6 9.26882 6.6 9.6002Z",
    fill: "#FF9400"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5854 1.56877C11.4433 1.84364 12 2.64516 12 3.52144V6.41511C12 9.51436 10.1241 12.3118 7.25682 13.4142L6.48876 13.7095C6.48875 13.7095 6.48877 13.7095 6.48876 13.7095C6.17415 13.8304 5.82599 13.8305 5.51129 13.7095C5.51128 13.7095 5.5113 13.7095 5.51129 13.7095L4.7432 13.4142C1.87595 12.3118 0 9.51436 0 6.41511V3.52141C0 2.64508 0.556795 1.8436 1.41462 1.56877C1.41461 1.56877 1.41463 1.56877 1.41462 1.56877L5.38704 0.296039C5.7859 0.168247 6.21415 0.168247 6.61301 0.296039L10.5854 1.56877ZM1.78075 2.71155C1.43525 2.82224 1.2 3.15029 1.2 3.52141V6.41511C1.2 9.03239 2.78354 11.3751 5.1738 12.2941L5.94188 12.5894C5.97935 12.6038 6.02065 12.6038 6.05813 12.5894L6.82619 12.2941C9.21646 11.3751 10.8 9.03239 10.8 6.41511V3.52144C10.8 3.1503 10.5648 2.82224 10.2193 2.71155L6.24688 1.43882C6.08614 1.38732 5.91391 1.38732 5.75318 1.43882L1.78075 2.71155Z",
    fill: "#FF9400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnverified);
export default __webpack_public_path__ + "static/media/unverified.a0c2eb17083a1ccd07f5acf01e95536c.svg";
export { ForwardRef as ReactComponent };